import PageForm from '../../../templates/PageForm';
import EventPlatformContent from './EventPlatformContent';
import EventPlatformTabs, { useTabNavigation } from './EventPlatformTabs';
import { useTopology } from './hooks/useTopology';
import TopologyRefresh from './TopologyRefresh';
import { LoadError } from './shared/ui';

const apiVersionOf = (meta: { apiVersion: string; environment: string } | null) =>
  meta ? `eventing ${meta.apiVersion} · ${meta.environment}` : 'eventing';

const EventPlatformPageView = () => {
  const topology = useTopology();
  const { active, index, goTo } = useTabNavigation();

  return (
    <PageForm
      pageTitle="Plataforma de eventos"
      apiVersion={apiVersionOf(topology.meta)}
      isLoading={!topology.data && topology.loading}
      breadcrumb={[
        { label: 'TI', url: '#' },
        { label: 'Plataforma de eventos', url: '/ti/event-platform/visao-geral' },
      ]}
      controlSlot={<TopologyRefresh topology={topology} />}
    >
      <div className="space-y-4 p-4 dark:bg-slate-800">
        <EventPlatformTabs topology={topology.data} index={index} onSelect={goTo} />
        {topology.error && <LoadError message={topology.error} onRetry={topology.reload} />}
        <EventPlatformContent active={active} topology={topology} onSelect={goTo} />
      </div>
    </PageForm>
  );
};

export default EventPlatformPageView;
